var __jsx = React.createElement;
import React from 'react';
import MuscleQuantityToggler from '../quantity-toggler';
// TODO: By now is a controlled input, but it should be a uncontrolled input as well
const MuscleQuantityTogglerInput = _ref => {
  let {
    label,
    description,
    value,
    onIncrement,
    onDecrement,
    minValue,
    maxValue,
    incrementDisabled = false,
    decrementDisabled = false,
    dataTestId
  } = _ref;
  return __jsx("div", {
    className: "flex flex-row gap-2 justify-between"
  }, __jsx("div", {
    className: "flex flex-col text-sm text-primary_text"
  }, __jsx("p", {
    className: "tx-psm-semiBold"
  }, label), __jsx("p", {
    className: "tx-pxs-regular"
  }, description)), __jsx(MuscleQuantityToggler, {
    value: value,
    incrementValue: onIncrement,
    decrementValue: onDecrement,
    minValue: minValue,
    maxValue: maxValue,
    incrementDisabled: incrementDisabled,
    decrementDisabled: decrementDisabled,
    dataTestId: dataTestId
  }));
};
export default MuscleQuantityTogglerInput;